export default {
  common: {
    selfExplanation: "Self Explanation",
    prompt: "Prompt",
    dontDisplayAgain: "Don't display this prompt again.",
    continue: "Continue",
    goBack: "Go back",

    cantFindTheCode: "Can't find the code: ",
    noContent: "No content",

    promptDisabledReopen: "You can reopen it in the [Home]->[My] page.",

    what: "What:",
    why: "Why:",
    learn: "Learn",
    toLearnOpen: "To learn more, please open"
  },
  E1000: {
    topic: "Objective",
    content_1_M: "Select the performance objective for this project, such as a chiller, chiller plant, or heating system. Heating plant and combined cooling and heating options are coming soon.",
    content_2_M:
      "This selection drives the iECM workflow by defining the system boundary, required inputs, applicable equipment configuration, and performance metrics used to evaluate improvement opportunities."
  },
  E10200: {
    topic: "Profile",
    content_1_M: "Setup the project profile, including purpose, design conditions, chiller configuration, weather profile, and pumping configuration, where applicable.",
    content_2_M: "This information helps iECM tailor the workflow, input fields, and energy audit logic to the selected objective, system type, and equipment configuration."
  },
  E10300: {
    topic: "Existing equipment specs",
    content_1_M: "Enter the existing site equipment details, including chillers and other applicable plant components, based on the selected objective.",
    content_2_M: "This helps iECM understand the current system and apply the right equipment data for the energy audit and retrofit analysis."
  },
  E10400: {
    topic: "Site observation",
    content_1_M: "Capture key findings, recommendations, expected benefits, and supporting photos from the customer site review.",
    content_2_M: "These notes explain why a retrofit is needed and strengthen the business case for the energy audit and proposal."
  },
  E10500: {
    topic: "Baseline configuration",
    content_1_M:
      "Choose the best data path to build the customer’s current energy baseline. Use either cooling load information or energy consumption bills, then set operating months and electricity rates for peak and off-peak periods.",
    content_2_M: "This selection defines the monthly baseline workflow and helps iECM build the reference case for the energy audit and annual savings estimate."
  },
  E10610: {
    topic: "Monthly baseline",
    content_1_M: "Add or edit the customer’s baseline-month operating profile. iECM uses this profile to estimate cooling loads for the rest of the year and calculate monthly chiller power.",
    content_2_M: "This builds a credible current-state baseline so annual energy savings and retrofit value can be compared clearly."
  },
  E10611: {
    topic: "Operating calendar",
    content_1_M: "Define when the customer’s system operates for this baseline, such as weekdays, weekends, or the full week. Monthly operating days are calculated automatically.",
    content_2_M: "Operating days show how often the system runs each month and throughout the year, forming the basis for annual load, energy, and savings calculations."
  },
  E10612: {
    topic: "Operating hours",
    content_1_M: "Define the 24-hour baseline-month operating schedule by marking each hour as peak, off-peak, or off.",
    content_2_M: "This links chiller operation to the appropriate weather profile for each period, helping iECM calculate load and power more accurately."
  },
  E10613: {
    topic: "Reference chiller",
    content_1_M: "Select the site chiller used during peak and off-peak periods, then choose the closest Carrier proxy model to represent its performance.",
    content_2_M: "iECM uses the proxy model and calibration inputs to simulate the customer’s chiller performance and calculate monthly baseline power more accurately."
  },
  E10614: {
    topic: "Operating load",
    content_1_M: "Set the number of chillers running each hour and their load ratio for the baseline day. iECM then calculates the hourly cooling load.",
    content_2_M: "This helps iECM build the annual cooling load profile and estimate how many chillers are needed under different monthly weather conditions."
  },
  E10615: {
    topic: "Monthly cooling load",
    content_1_M: "Review the weighted average cooling load for each month. The baseline month is based on hourly inputs, while the other months are estimated by iECM.",
    content_2_M: "These monthly loads define the cooling demand baseline used to estimate chiller operation, energy use, and savings compared with retrofit solutions."
  },
  E10616: {
    topic: "Monthly chiller count",
    content_1_M: "Review the minimum chiller count required for peak and off-peak operation each month, based on monthly cooling load and available chiller capacity.",
    content_2_M: "This helps iECM estimate how the existing chillers operate throughout the year and supports monthly baseline power and energy calculations."
  },
  E10617: {
    topic: "Chiller power",
    content_1_M: "Review the monthly average chiller power for peak and off-peak periods, calculated from the proxy chiller model, cooling load, and chiller count.",
    content_2_M: "This power profile is used to estimate baseline chiller energy use and compare savings against retrofit solutions."
  },
  E10620: {
    topic: "Monthly baseline",
    content_1_M: "Add or edit monthly baseline configurations based on the customer’s operating patterns, such as weekday and weekend operation.",
    content_2_M: "These baselines organize the utility bill workflow and help iECM build the current energy baseline for annual savings and retrofit value comparison."
  },
  E10621: {
    topic: "Operating calendar",
    content_1_M: "Define when the customer’s system operates for this baseline, such as weekdays, weekends, or the full week. Monthly operating days are calculated automatically.",
    content_2_M: "Operating days show how often the system runs each month and throughout the year, forming the basis for annual load, energy, and savings calculations."
  },
  E10622: {
    topic: "Running hours",
    content_1_M: "Enter the daily running hours for peak and off-peak periods in each month, based on the customer’s operating schedule.",
    content_2_M: "This links chiller operation to the appropriate weather profile for each period, helping iECM calculate power more accurately."
  },
  E10623: {
    topic: "Reference chiller",
    content_1_M: "Select the site chiller used during peak and off-peak periods, then choose the closest Carrier proxy model to represent its performance.",
    content_2_M: "iECM uses the proxy model and calibration inputs to simulate the customer’s chiller performance and calculate monthly baseline cooling load more accurately."
  },
  E10624: {
    topic: "Energy consumption",
    content_1_M: "Enter the customer’s monthly energy consumption for peak and off-peak periods using utility bill data.",
    content_2_M: "This helps iECM convert bill data into an operating baseline, including estimated chiller power, required chiller count, and cooling load demand."
  },
  E10625: {
    topic: "Chiller power",
    content_1_M: "Review the monthly weighted average chiller power calculated from the customer’s utility bill data for peak and off-peak periods.",
    content_2_M: "This weighted average power is used to estimate chiller operation, cooling load demand, and savings compared with retrofit solutions."
  },
  E10626: {
    topic: "Monthly chiller count",
    content_1_M: "Review the minimum chiller count required for peak and off-peak operation each month, based on monthly average cooling power and available chiller power.",
    content_2_M: "This helps iECM estimate how the existing chillers operate throughout the year and supports monthly cooling load baseline and energy calculations."
  },
  E10627: {
    topic: "Monthly cooling load",
    content_1_M: "Review the monthly weighted average cooling load derived from utility bill data, proxy chiller performance, monthly chiller power, and chiller count.",
    content_2_M: "This cooling load profile represents the same building demand before and after retrofit, enabling a fair comparison of current and proposed equipment."
  },
  E10628: {
    topic: "Auxiliary power",
    content_1_M: "Enter the actual weighted average operating power (kW) for auxiliary equipment, such as pumps and cooling towers, during peak and off-peak periods.",
    content_2_M: "This helps iECM include auxiliary equipment energy use in the current baseline and calculate total baseline energy use more accurately."
  },
  E10700: {
    topic: "Baseline preview",
    content_1_M: "Review and download the baseline baseline energy audit results, including hourly cooling load, estimated power, and monthly load and power by equipment type.",
    content_2_M: "This confirms the baseline baseline results and generates a customer-ready energy audit report before proposed modeling begins."
  },
  E10800: {
    topic: "Setup operating condition",
    content_1_M: "Select the new chiller type and set the proposed operating conditions, such as chilled water temperature and condenser-side settings.",
    content_2_M: "This helps iECM configure the proposed setup and estimate performance based on the selected equipment type."
  },
  E10900: {
    topic: "Define new equipment",
    content_1_M: "Add and define the new equipment used in the retrofit solution, including chillers, pumps, and cooling towers where applicable. Each entry represents one equipment unit.",
    content_2_M: "Define each equipment option once. iECM calculates the required operating quantities and uses them to estimate retrofit performance, energy savings, and ROI."
  },
  E10901: {
    topic: "Digital e-CAT",
    content_1_M: "Choose a new chiller from digital e-CAT, set design conditions and selling price, and review its performance curve.",
    content_2_M:
      "This makes chiller selection faster and easier while providing the performance data needed for retrofit analysis and savings calculation. The unit selling price is used to estimate total project CAPEX."
  },
  E10902: {
    topic: "Cluster months",
    content_1_M: "Use cluster months when the desired chiller is not available in the digital e-CAT library. Cluster similar months, then enter chiller details and e-CAT performance data.",
    content_2_M:
      "Month clustering reduces repeated e-CAT inputs, while manual entry lets iECM analyze custom chillers for retrofit analysis and savings calculation. The unit selling price is used to estimate total CAPEX."
  },
  E10903: {
    topic: "Pump",
    content_1_M: "Define the new pump and link it to the chiller it will support in the retrofit solution.",
    content_2_M: "This helps iECM model the proposed solution correctly by matching each pump with the appropriate operating chiller."
  },
  E10904: {
    topic: "Cooling tower",
    content_1_M: "",
    content_2_M: "This helps iECM model the proposed solution correctly by matching each cooling tower with the appropriate operating chiller."
  },
  E11000: {
    topic: "Retrofit solution",
    content_1_M:
      "Review iECM-generated retrofit solutions, rank them by efficiency, ROI, or investment, and complete the required configuration for each option. Generate the ECM report or reconfigure a solution for a custom setup.",
    content_2_M: "This helps you choose the strongest customer proposal, fine-tune ROI, NPV, and the proposed configuration, and generate the final ECM report."
  },
  E12000: {
    topic: "Reconfigured solution",
    content_1_M: "Manually configure a retrofit solution by selecting the associated chiller and maximum running quantity for each baseline and operating period.",
    content_2_M: "This gives you flexibility to tailor the proposal when the auto-generated solution is not the best fit for the customer"
  },
  E11001: {
    topic: "Retrofit configuration",
    content_1_M: "Review the detailed configuration of the retrofit solution, including maximum cooling load, proposed chiller capacity, and monthly running equipment counts.",
    content_2_M: "This confirms how the proposed system is sized and operated before it is used for financial analysis and the final ECM report."
  },
  E11002: {
    topic: "ROI & NPV",
    content_1_M: "Review and update the lifecycle financial performance of the solution, including energy savings, cost savings, ROI, payback period, and NPV for the chiller plant or chiller.",
    content_2_M: "This shows the customer how the solution improves efficiency, reduces operating cost, and delivers long-term financial value, including ROI and NPV."
  },
  E11003: {
    topic: "Equipment details proposed",
    content_1_M: "Define the detailed retrofit scope and configuration by selecting which existing equipment will remain and which new equipment will replace it.",
    content_2_M: "This clarifies the proposed equipment changes and helps create a complete, customer-ready retrofit plan and ECM report."
  },
  E11004: {
    topic: "Proposed configuration",
    content_1_M: "Enter the analysis assumptions, system details, and energy conservation measures to include in the final ECM report.",
    content_2_M: "This helps create a complete, customer-ready report that clearly explains the retrofit basis, proposed measures, and expected value."
  },
  // HEATING
  E2000: {
    topic: "Objective",
    content_1_M:
      "Select the performance objective of this project. You can define whether the evaluation is for a single chiller, a chiller plant or a heating system (heat pump retrofit and integrated cooling & heating plant coming soon).",
    content_2_M:
      "This choice drives the rest of the iECM workflow. It determines the system boundary, required user inputs, applicable equipment configuration, and the performance metrics used to assess improvement opportunities."
  },
  E20200: {
    topic: "Profile",
    content_1_M: "Enter the basic project information and design assumptions, including project purpose, location and weather data, heating application, design conditions, and system configuration.",
    content_2_M: "These inputs allow iECM to tailor the heating workflow and calculations to the site, climate, application, and existing system."
  },
  E20300: {
    topic: "Existing equipment specifications",
    content_1_M: "Add the existing heating equipment and enter the key specifications for each unit, such as equipment type, capacity, quantity, fuel or energy type, and efficiency-related data.",
    content_2_M: "This defines the current heating system and provides the equipment information needed to establish the baseline and evaluate replacement options."
  },
  E20400: {
    topic: "Site observation",
    content_1_M: "Record site findings, observed issues, recommendations, expected benefits, and supporting photos from the customer site review.",
    content_2_M: "Site observations explain the practical reasons for the retrofit and provide supporting evidence for the energy audit and customer proposal."
  },
  E20500: {
    topic: "Baseline configuration",
    content_1_M:
      "Select the available baseline data path: Path A based on heating-load information, or Path B based on energy-consumption data. Then define operating months and applicable energy prices or tariffs.",
    content_2_M: "The selected path determines how the monthly heating baseline is developed and how annual energy cost and savings are evaluated."
  },
  E20610: {
    topic: "Monthly baseline",
    content_1_M: "Add or edit the representative monthly operating profile used to establish the heating baseline and estimate the remaining months of the year.",
    content_2_M: "A representative operating profile provides a consistent basis for estimating annual heating demand, energy consumption, and retrofit savings."
  },
  E20611: {
    topic: "Operating calendar",
    content_1_M: "Define the system operating days, such as weekdays, weekends, or the full week. iECM calculates the corresponding operating days for each month.",
    content_2_M: "Operating days determine how often the heating system runs and are a key input to monthly and annual load, energy, and savings calculations."
  },
  E20612: {
    topic: "Running hours",
    content_1_M: "Enter the daily operating hours for peak and off-peak periods in each month based on the customer’s actual schedule.",
    content_2_M: "This allocates heating operation to the correct time periods and weather conditions, improving the accuracy of load, energy, and cost calculations."
  },
  E20613: {
    topic: "Boiler operation",
    content_1_M: "Select the existing boiler or heating equipment operating during peak and off-peak periods and confirm the applicable operating and performance inputs.",
    content_2_M: "This connects the existing equipment to the monthly heating demand so iECM can estimate baseline equipment operation and energy consumption."
  },
  E20615: {
    topic: "Monthly heating load",
    content_1_M:
      "Review the average heating load for peak and off-peak periods in each month. The representative month is based on the entered load profile, and the other months are estimated by iECM.",
    content_2_M: "The monthly load profile defines the heating-demand baseline used to size equipment operation, calculate energy use, and compare retrofit solutions."
  },
  E20616: {
    topic: "Monthly boiler count",
    content_1_M: "Review the minimum number of existing boilers or heating units required during peak and off-peak periods in each month, based on heating load and available equipment capacity.",
    content_2_M: "The operating equipment count shows how the existing system meets monthly demand and supports the baseline energy calculation."
  },
  E20617: {
    topic: "Monthly energy consumption",
    content_1_M: "Review the estimated monthly energy consumption for peak and off-peak periods, calculated from the heating load, equipment operation, and existing-equipment performance.",
    content_2_M: "This establishes the pre-retrofit energy baseline used to calculate annual energy cost and compare savings from proposed solutions."
  },
  E20623: {
    topic: "Boiler operation",
    content_1_M: "Select the existing boiler or heating equipment associated with the reported energy consumption and confirm the applicable operating and performance inputs.",
    content_2_M: "This links the energy-consumption baseline to the actual heating equipment and supports conversion of energy use into heating demand and operating requirements."
  },
  E20627: {
    topic: "Monthly energy consumption",
    content_1_M: "Enter or review the customer’s monthly heating energy consumption and its peak and off-peak allocation, where applicable.",
    content_2_M: "The consumption data provides the primary baseline input for estimating monthly heating demand, current energy cost, and retrofit savings."
  },
  E20626: {
    topic: "Monthly boiler count",
    content_1_M: "Review the estimated number of existing boilers or heating units required during peak and off-peak periods in each month.",
    content_2_M: "This indicates how the existing equipment is expected to operate to serve the demand derived from the energy-consumption baseline."
  },
  E20625: {
    topic: "Monthly heating load",
    content_1_M: "Review the monthly heating load estimated from the energy-consumption data, operating profile, and existing-equipment performance.",
    content_2_M: "The derived load profile provides the common heating-demand basis needed to size and compare proposed retrofit solutions."
  },
  E20700: {
    topic: "Baseline preview",
    content_1_M: "Review the baseline results, including monthly heating demand, energy consumption, and energy cost, and download the baseline energy-audit report.",
    content_2_M: "This allows the user to verify the pre-retrofit reference case before proceeding to proposed-equipment and retrofit-solution analysis."
  },
  E20800: {
    topic: "Setup operating conditions",
    content_1_M: "Select the proposed heat-pump type and define the post-retrofit operating conditions, including load-side and source-side temperature conditions as applicable.",
    content_2_M: "Operating conditions determine the heat pump’s capacity and efficiency and are therefore essential for accurate proposed-system performance calculations."
  },
  E20900: {
    topic: "Define new equipment",
    content_1_M: "Add the proposed heat-pump options and define the key information for each equipment unit.",
    content_2_M: "Each equipment option is defined once so iECM can determine the required operating quantity and evaluate performance, savings, investment, and financial return."
  },
  E20901: {
    topic: "Heat pump selection: digital e-CAT",
    content_1_M: "Select a heat pump from digital e-CAT, define the design conditions and unit selling price, and review the available performance data.",
    content_2_M: "digital e-CAT provides consistent equipment-selection and performance data for retrofit analysis, while the selling price contributes to the estimated project CAPEX."
  },
  E20902: {
    topic: "Heat pump selection: cluster months",
    content_1_M:
      "Use Manual Design when the required heat pump is not available in digital e-CAT. Group months with similar operating conditions, then enter the equipment and performance data for each cluster.",
    content_2_M:
      "Month clustering reduces repeated data entry while allowing custom equipment to be evaluated across representative annual operating conditions. The selling price contributes to estimated CAPEX."
  },
  E21000: {
    topic: "Modernisierungslösungen",
    content_1_M:
      "Review the solutions generated by iECM, compare or rank them by efficiency, financial return, or investment, complete the required configuration, and generate the ECM report. A solution can also be reconfigured manually.",
    content_2_M: "This helps identify a suitable customer proposal, refine the equipment configuration and financial assumptions, and produce the final retrofit report."
  },
  E22000: {
    topic: "Reconfigured solution",
    content_1_M: "Manually configure a retrofit solution by selecting the proposed equipment and setting the maximum operating quantity for each baseline month and operating period.",
    content_2_M: "This provides flexibility to create a customer-specific configuration when an automatically generated solution does not fully meet project needs."
  },
  E21001: {
    topic: "Retrofit configuration",
    content_1_M: "Review the detailed solution configuration, including maximum heating load, proposed heat-pump capacity, and monthly operating equipment counts.",
    content_2_M: "This confirms that the proposed system is appropriately sized and operated before financial evaluation and final report generation."
  },
  E21002: {
    topic: "ROI & NPV",
    content_1_M: "Review and update the lifecycle financial results, including energy and cost savings, investment, ROI, payback period, and NPV.",
    content_2_M: "This demonstrates the solution’s operating-cost reduction and long-term financial value and supports customer investment decisions."
  },
  E21004: {
    topic: "Proposed equipment details",
    content_1_M: "Define the detailed retrofit scope by identifying which existing equipment will remain and which proposed equipment will be added or used as replacement.",
    content_2_M: "This clearly documents the equipment changes and supports a complete, customer-ready retrofit plan and ECM report."
  },
  // wizard mode related
  E13000: {
    topic: "Quick Setup",
    content_1_M: "Quick Setup collects the key project, existing equipment, and proposed equipment information needed to create an initial baseline and retrofit model.",
    content_2_M:
      "It enables iECM to perform an early assessment with limited site data. iECM uses the provided inputs and reference models to generate initial assumptions, which can be reviewed and adjusted before calculation."
  },
  E13001: {
    topic: "Review Assumptions",
    content_1_M: "Input minimum required data, including building vertical, estimated path, job-site chiller, reference chiller, proposed chiller and monthly tariff. ",
    content_2_M: "This together with automated assumptions and default values will deliver fast calculation and quick report generation experience."
  },
  E13002: {
    topic: "Assessment Results",
    content_1_M: "Input minimum required data, including building vertical, estimated path, job-site chiller, reference chiller, proposed chiller and monthly tariff. ",
    content_2_M: "This together with automated assumptions and default values will deliver fast calculation and quick report generation experience."
  }
}



// WEBPACK FOOTER //
// ./src/locale/explan/en.js